"use strict";

function expandPrevious(event) {
  var src = event.srcElement,
      data = src.dataset,
      target = src.previousElementSibling;

  if (target.classList.contains('is-expanded')) {
    src.innerHTML = data.moreText;
  } else {
    src.innerHTML = data.lessText;
  }

  target.classList.toggle('is-expanded');
}